export default "__VITE_ASSET__CS2VKFcM__"